import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getCurrentEdition () {
        return httpService.get(ApiEndpoints.get('edition'));
    }
};
